import React from "react";
import { Route, Switch } from "react-router-dom";
import { Col } from "react-bootstrap";

import PlanPage from "../PlanPage";

const PlanIdRouting = () => {

    return (
    <>
      <Col name="planid-routing">
        <Switch>          
          <Route path="/options/plans/:planId" component={PlanPage} />
        </Switch>      
      </Col>

    </>
  );

};

export default PlanIdRouting;